import {MessageCodes} from "../MessageCodes";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.ES000.error_id: {
            const baseData = row.data.filter(x => x.type === 'base')
            const comparisonData = row.data.filter(x => x.type === 'comparison')

            let base = (<div></div>);
            if(baseData.length > 0) {
                base = (
                    <>
                        {globalVariables?.sel_plan_title || 'Base'} Plan:{' '}
                        <ComparisonCSName csNameList={baseData.map(x => x.cross_section)} />
                    </>
                )
            }

            let comparison = (<div></div>);
            if(comparisonData.length > 0) {
                comparison = (
                    <>
                        {globalVariables?.tar_plan_title || 'Comparison'} Plan:{' '}
                        <ComparisonCSName csNameList={comparisonData.map(x => x.cross_section)} />
                    </>
                )
            }
            return (
                <>
                    <div>
                        The following cross sections do not have any defined encroachment stations in plan file because their encroachment method is not set as Method 1. Therefore, encroachment stations are not compared for these cross sections.
                    </div>
                    <div>
                        {base}
                        <br/>
                        {comparison}
                    </div>
                </>
            )
        }
        case MessageCodes.Compare.ES001.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in Encroachment Station placements between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plan at the following {row?.data?.length} cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell rowSpan={3} style={{textAlign: 'left', verticalAlign: 'bottom'}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell colSpan={4} style={{textAlign: 'center'}}>
                                Encroachment Station (ft)
                            </ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                            <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                        </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Left</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Right</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Left</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Right</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            row.data?.map(r => (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'left', width: 100}}><ComparisonCSName csName={r.cross_section} /></ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 75}}>{r.base_left}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 75}}>{r.base_right}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 75}}>{ResultCellHighlight(r.base_left, r.compare_left)}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 75}}>{ResultCellHighlight(r.base_right, r.compare_right)}</ResultBodyCell>
                                </ResultRow>
                            ))
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.TTOPW001.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in left and right Encroachment Top Width between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plan at the following {row?.data?.length} cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell rowSpan={3} style={{textAlign: 'left', verticalAlign: 'bottom'}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell colSpan={7} style={{textAlign: 'center'}}>
                                Top Width (ft)
                            </ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                            <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right'}}>Difference</ResultHeaderCell>
                        </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Left</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Right</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Left</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Right</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Total</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            row.data?.map(r => (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'left', width: 100}}><ComparisonCSName csName={r.cross_section} /></ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 75}}>{r?.base?.sel_topW_L}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 75}}>{r.base?.sel_topW_R}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 75}}>{ResultCellHighlight(r?.base?.sel_topW_L, r.compare?.tar_topW_L)}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 75}}>{ResultCellHighlight(r?.base?.sel_topW_R, r.compare?.tar_topW_R)}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', width: 75}}>{r.diff}</ResultBodyCell>
                                </ResultRow>
                            ))
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const C7 = {
    RenderDescription,
}